import { CheckCircle, Clock, EyeIcon, XCircle } from 'lucide-react';

interface ApprovalShortViewProps {
    approvalStatus: 'completed' | 'rejected' | 'pending';
    completedCount: number;
    totalCount: number;
    onExpand: () => void;
}

const statusConfigs = {
    completed: {
        container: 'bg-gradient-to-r from-green-50 to-emerald-50 hover:border-green-300 hover:shadow-md',
        icon: 'bg-gradient-to-br from-green-500 to-green-600',
        iconComponent: CheckCircle,
        title: 'text-green-900',
        subtitle: 'text-green-700',
        button: 'text-green-600 bg-white/70 group-hover:bg-white/90',
        text: 'อนุมัติเสร็จสิ้นแล้ว'
    },
    rejected: {
        container: 'bg-gradient-to-r from-red-50 to-rose-50 hover:border-red-300 hover:shadow-md',
        icon: 'bg-gradient-to-br from-red-500 to-red-600',
        iconComponent: XCircle,
        title: 'text-red-900',
        subtitle: 'text-red-700',
        button: 'text-red-600 bg-white/70 group-hover:bg-white/90',
        text: 'การอนุมัติถูกปฏิเสธ'
    },
    pending: {
        container: 'bg-gradient-to-r from-amber-50 to-orange-50 hover:border-amber-300 hover:shadow-md',
        icon: 'bg-gradient-to-br from-amber-500 to-orange-600',
        iconComponent: Clock,
        title: 'text-amber-900',
        subtitle: 'text-amber-700',
        button: 'text-amber-600 bg-white/70 group-hover:bg-white/90',
        text: 'รอการอนุมัติ'
    }
} as const;

const ApprovalShortView: React.FC<ApprovalShortViewProps> = ({
    approvalStatus,
    completedCount,
    totalCount,
    onExpand
}) => {
    const config = statusConfigs[approvalStatus];
    const StatusIcon = config.iconComponent;

    return (
        <div className="cursor-pointer group" onClick={onExpand}>
            <div className={`flex items-center justify-between p-4 rounded-xl transition-all duration-200 group-hover:shadow-lg ${config.container}`}>
                <div className="flex items-center gap-4">
                    <div className={`relative p-2 rounded-xl shadow-md ${config.icon}`}>
                        <StatusIcon className="h-5 w-5 text-white" />
                        {approvalStatus === 'pending' && (
                            <div className="absolute -top-1 -right-1 w-3 h-3 bg-amber-400 rounded-full animate-ping"></div>
                        )}
                    </div>
                    <div className='flex flex-col gap-1'>
                        <div className={`text-base font-bold ${config.title}`}>
                            {config.text}
                        </div>
                        <span className={`text-xs xs:text-base ${config.subtitle}`}>
                            {completedCount}/{totalCount} ขั้นตอนเสร็จสิ้น
                            {approvalStatus === 'completed' && <span className="ml-1">✓</span>}
                        </span>
                    </div>
                </div>
                <div className="flex items-center gap-3">
                    <div className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-colors duration-200 shadow-md ${config.button}`}>
                        <EyeIcon className="h-4 w-4 inline-block xs:mr-1" />
                        <span className="hidden xs:inline">ดูรายละเอียด</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApprovalShortView;
